import { useState } from "react";
import { Card, CardContent, CardMedia, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {blogs} from "./blogs";

const CARD_WIDTH = 300;

const BlogCarousel = () => {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();
  const VISIBLE_CARDS = 3;
  const maxIndex = Math.max(blogs.length - VISIBLE_CARDS, 0);

  const next = () => setIndex(i => (i >= maxIndex ? 0 : i + 1));
  const prev = () => setIndex(i => (i === 0 ? maxIndex : i - 1));

  const handleBlogClick = (blogId) => {
    navigate(`/blog/${blogId}`);
  };

  const handleReadMore = (e, blog) => {
    e.stopPropagation();
    navigate(`/blog/${blog.id}/details`, { state: { blog } });
  };

  const handleAddExt = (e, blogId) => {
    e.stopPropagation();
    navigate(`/blog/${blogId}/ext`);
  };

  return (
    <section className="w-full bg-gray-50 py-16">
      <h2 className="text-3xl font-semibold text-center mb-10">Latest Blogs</h2>
      <div className="relative max-w-[1200px] mx-auto">
        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${index * (CARD_WIDTH + 16)}px)` }}
          >
            {blogs.map((blog) => (
              <div 
                key={blog.id} 
                className="flex-shrink-0 w-[300px] mx-2 cursor-pointer"
                onClick={() => handleBlogClick(blog.id)}
              >
                <Card className="rounded-xl shadow-lg flex flex-col hover:shadow-xl transition-shadow" style={{ width: CARD_WIDTH }}>
                  <CardMedia
                    component="img"
                    image={blog.image}
                    alt={blog.title}
                    style={{ height: 160 }}
                  />
                  <CardContent className="flex flex-col justify-between flex-1">
                    <div>
                      <h3 className="font-semibold mb-2">{blog.title}</h3>
                      <p className="text-sm text-gray-700 line-clamp-3">{blog.excerpt}</p>
                    </div>
                    <div className="flex gap-2 mt-3">
                      <Button
                        variant="contained"
                        sx={{
                          flex: 1,
                          px: 2,
                          py: 0.9,
                          minHeight: "36px",
                          borderRadius: "10px",
                          background: "linear-gradient(135deg, #166534, #15803d)",
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: "0.9rem",
                          textTransform: "none",
                          boxShadow: "0 6px 14px rgba(22, 101, 52, 0.25)",
                          "&:hover": {
                            background: "linear-gradient(135deg, #14532d, #166534)",
                          },
                        }}
                        onClick={(e) => handleReadMore(e, blog)}
                      >
                        Read More
                      </Button>
                      
                    </div>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>

        {/* Arrows */}
        <button 
          onClick={prev} 
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow-lg rounded-full w-12 h-12 flex items-center justify-center hover:bg-green-100 transition z-10"
        >
          ←
        </button>
        <button 
          onClick={next} 
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow-lg rounded-full w-12 h-12 flex items-center justify-center hover:bg-green-100 transition z-10"
        >
          →
        </button>
      </div>
    </section>
  );
};

export default BlogCarousel;